// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_STITCHING_INWARD_REQUEST = 'FETCH_STITCHING_INWARD_REQUEST';
export const FETCH_STITCHING_INWARD_SUCCESS = 'FETCH_STITCHING_INWARD_SUCCESS';
export const FETCH_STITCHING_INWARD_FAILURE = 'FETCH_STITCHING_INWARD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_STITCHING_INWARD_REQUEST = 'CREATE_STITCHING_INWARD_REQUEST';
export const CREATE_STITCHING_INWARD_SUCCESS = 'CREATE_STITCHING_INWARD_SUCCESS';
export const CREATE_STITCHING_INWARD_FAILURE = 'CREATE_STITCHING_INWARD_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_STITCHING_INWARD = 'CREATE_USER_FORM_STITCHING_INWARD';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_STITCHING_INWARD_REQUEST = 'UPDATE_STITCHING_INWARD_REQUEST';
export const UPDATE_STITCHING_INWARD_SUCCESS = 'UPDATE_STITCHING_INWARD_SUCCESS';
export const UPDATE_STITCHING_INWARD_FAILURE = 'UPDATE_STITCHING_INWARD_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_STITCHING_INWARD_REQUEST = 'FETCH_SINGLE_STITCHING_INWARD_REQUEST';
export const FETCH_SINGLE_STITCHING_INWARD_SUCCESS = 'FETCH_SINGLE_STITCHING_INWARD_SUCCESS';
export const FETCH_SINGLE_STITCHING_INWARD_FAILURE = 'FETCH_SINGLE_STITCHING_INWARD_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_STITCHING_INWARD_REQUEST = 'DELETE_STITCHING_INWARD_REQUEST';
export const DELETE_STITCHING_INWARD_SUCCESS = 'DELETE_STITCHING_INWARD_SUCCESS';
export const DELETE_STITCHING_INWARD_FAILURE = 'DELETE_STITCHING_INWARD_FAILURE';

export const FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE';

// USERFORM RESET

export const STITCHING_INWARD_USERFORM_RESET = 'STITCHING_INWARD_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_STITCHING_INWARD_DETAILS = 'NAVIGATE_STITCHING_INWARD_DETAILS';
// navigate to company component
export const NAVIGATE_STITCHING_INWARD = 'NAVIGATE_STITCHING_INWARD';

export const SET_ACTIVE_KEY_STITCHING_INWARD = 'SET_ACTIVE_KEY_STITCHING_INWARD';
export const RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID';



export const FETCH_DELETE_STITCHING_PO_IN_INWARD_REQUEST = 'FETCH_DELETE_STITCHING_PO_IN_INWARD_REQUEST';
export const FETCH_DELETE_STITCHING_PO_IN_INWARD_SUCCESS = 'FETCH_DELETE_STITCHING_PO_IN_INWARD_SUCCESS';
export const FETCH_DELETE_STITCHING_PO_IN_INWARD_FAILURE = 'FETCH_DELETE_STITCHING_PO_IN_INWARD_FAILURE';

export const SET_UNIT_NAME_STITCHING_INWARD = 'SET_UNIT_NAME_STITCHING_INWARD';
export const SET_START_DATE_STITCHING_INWARD = 'SET_START_DATE_STITCHING_INWARD';
export const SET_END_DATE_STITCHING_INWARD = 'SET_END_DATE_STITCHING_INWARD';
